// Run this code when the DOM is fully loaded
document.addEventListener("DOMContentLoaded", function () {
  toggleDarkModeVisibility();
  toggle_mode_button_version2();
  const checkbox = document.querySelector(".dark-mode-checkbox");
  if (!checkbox) return;
  darkModeHandler(checkbox);  // Apply saved theme and handle checkbox changes
  setupKeyboardToggle(checkbox); // Enable keyboard support for dark mode toggle

});

function darkModeHandler(checkbox) {
  // Load initial mode from localStorage
  const darkModeEnabled = localStorage.getItem("ps-wp-theme") === "dark";
  if (darkModeEnabled) {
    document.body.classList.add("dark");
    checkbox.checked = true;
  }

  // Toggle dark mode on checkbox change
  checkbox.addEventListener("change", () => {
    if (checkbox.checked) {
      document.body.classList.add("dark");
      localStorage.setItem("ps-wp-theme", "dark");
    } else {
      document.body.classList.remove("dark");
      localStorage.setItem("ps-wp-theme", "light");
    }
  });
}
//  Adds keyboard accessibility to the dark mode toggle label

function setupKeyboardToggle(checkbox) {
  const label = document.querySelector('.dark-mode-checkbox-label');
  if (label) {
    label.addEventListener('keydown', function (e) {
      // Trigger toggle when Enter or Space is pressed
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        checkbox.checked = !checkbox.checked;
        checkbox.dispatchEvent(new Event('change'));
      }
    });
  }
}

//Controls visibility of the dark mode toggle based on mobile menu state
function toggleDarkModeVisibility() {
  const menuOpener = document.querySelector(".mobile-menu-opener");
  const menuCloseBtn = document.querySelector(".mobile-menu-close-button");
  const mobileMenu = document.querySelector(".mobile-menu");
  const darkModeContainer = document.querySelector(".dark-mode-container");
  // Show/hide dark mode toggle when menu opens/closes
  if (menuOpener && menuCloseBtn && mobileMenu && darkModeContainer) {
    menuOpener.addEventListener("click", function () {
      if (mobileMenu.classList.contains("active")) {
        darkModeContainer.style.display = "none";
      } else {
        darkModeContainer.style.display = "block";
      }
    });
    menuCloseBtn.addEventListener("click", function () {
      mobileMenu.classList.remove("active");
      darkModeContainer.style.display = "block";
    });
  }
}

// * Enables a button-based toggle for dark mode (alternative to checkbox)
function toggle_mode_button_version2() {
  const toggleButton = document.getElementById("theme-toggle");
  if (!toggleButton) return;

  // Load and apply saved theme
  const darkModeEnabled = localStorage.getItem("ps-wp-theme") === "dark";
  if (darkModeEnabled) {
    document.body.classList.add("dark");
    toggleButton.classList.add("dark"); // <== use .dark on button too
  }

  // Toggle dark mode on button click
  toggleButton.addEventListener("click", function () {
    const isDark = document.body.classList.toggle("dark");
    localStorage.setItem("ps-wp-theme", isDark ? "dark" : "light");

    this.classList.toggle("dark", isDark); // <== use .dark on button too
  });
}


